<template>
  <div class="home">
    <LinkComponent/>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import LinkComponent from '@/components/LinkComponent.vue' // @ is an alias to /src

@Options({
  components: {
    LinkComponent
  }
})
export default class HomeView extends Vue {}
</script>
